<template>
    <div class="flex flex-col">
        <select
            v-model="year"
            class="border border-gray-300 px-2 py-2.5 text-[16px] focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] focus:outline-none focus:outline-offset-0"
            :class="yearInputClass"
            :disabled="disabled"
        >
            <option
                :key="0"
                :value="0"
            >
                {{ t('dropdownDateInput.year') }}
            </option>
            <option
                v-for="year in yearOptions"
                :key="year"
                :value="year"
            >
                {{ year }}
            </option>
        </select>
        <small
            v-if="showYearError"
            id="year-help"
            class="text-red-600"
            >{{ t('dropdownDateInput.yearRequired') }}</small
        >
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps<{
    selectedYear: number
    disabled: boolean
    invalid: boolean
    showErrors: boolean
}>()

const emit = defineEmits<{
    (e: 'update:selected-year', payload: number)
}>()

const { t } = useI18n({ useScope: 'global' })

// Vue does something to get the value from the options, I think,
// so I'm using the writable computed here to take advantage of that
// Using the raw event makes everything a string
const year = computed({
    get() {
        return props.selectedYear
    },
    set(newValue) {
        emit('update:selected-year', newValue)
    }
})

const showYearError = computed(() => {
    return props.selectedYear === 0 && props.showErrors
})

const yearInputClass = computed(() => {
    if (props.disabled === true) {
        return 'text-gray-500'
    } else if (showYearError.value || props.invalid) {
        return 'border-2 border-red-500'
    } else {
        return ''
    }
})

const yearOptions: number[] = []
for (
    let i = new Date().getFullYear() - 120;
    i <= new Date().getFullYear();
    i++
) {
    yearOptions.unshift(i)
}
</script>
